module.exports = __webpack_public_path__ + "static/media/cwiczenia-z-jezyka-polskiego-dla-dzieci-ws1.45378ade.png";